import { useEffect, useState } from "react";
import { api, API_URL } from "../api";
import Modal from "react-modal";

Modal.setAppElement("#root");

export default function Home() {
  const [about, setAbout] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [reservedDates, setReservedDates] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get("/public/about"),
      api.get("/public/photos"),
      api.get("/public/available-dates"),
    ])
      .then(([aboutRes, photosRes, datesRes]) => {
        setAbout(aboutRes.data);
        setPhotos(photosRes.data);
        setReservedDates(datesRes.data.reservedDates || []);
      })
      .catch(() => {});
  }, []);

  return (
    <>
      {/* Hero */}
      <section
        className="relative overflow-hidden rounded-3xl border border-orange-300/20 p-8 md:p-14"
        style={{
          backgroundImage: `linear-gradient(rgba(8,8,8,.55),rgba(8,8,8,.55)), url(${API_URL}/images/banner-djcarbajal.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute -left-20 -top-20 h-56 w-56 rounded-full bg-orange-500/25 blur-3xl" />
        <div className="absolute -bottom-24 -right-12 h-64 w-64 rounded-full bg-amber-300/20 blur-3xl" />
        <h1 className="relative z-10 max-w-3xl text-4xl font-black uppercase tracking-wider md:text-6xl">
          DJ CARBAJAL
        </h1>
        <p className="relative z-10 mt-2 text-xl font-semibold text-orange-300">Feel the sound</p>
        <p className="relative z-10 mt-6 max-w-2xl text-sm text-orange-50/90 md:text-base">
          {about?.description || "Proyecto musical para eventos sociales y corporativos."}
        </p>
      </section>

      {/* Fechas reservadas */}
      <section className="mt-10 rounded-2xl border border-orange-400/20 bg-black/20 p-6">
        <h2 className="text-xl font-bold uppercase tracking-wide">Fechas Reservadas</h2>
        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
          {reservedDates.length === 0 && <p className="col-span-full text-sm text-orange-100/60">No hay fechas reservadas aun.</p>}
          {reservedDates.map((d) => (
            <div key={d} className="rounded-lg bg-orange-500/10 px-4 py-3 text-center text-sm font-medium">
              {new Date(d).toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" })}
            </div>
          ))}
        </div>
      </section>

      {/* Galeria */}
      <section className="mt-10 rounded-2xl border border-orange-400/20 bg-black/20 p-6">
        <h2 className="text-xl font-bold uppercase tracking-wide">Galeria</h2>
        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {photos.length === 0 && <p className="col-span-full text-sm text-orange-100/60">No hay fotos registradas.</p>}
          {photos.map((p) => (
            <img
              key={p.id}
              src={`${API_URL}/images/${p.fileName}`}
              alt="DJ evento"
              className="h-40 w-full rounded-xl border border-orange-300/20 object-cover transition-transform hover:scale-105 cursor-pointer"
              onClick={() => {
                setCurrentImage(`${API_URL}/images/${p.fileName}`);
                setLightboxOpen(true);
              }}
            />
          ))}
        </div>
      </section>

      {lightboxOpen && (
        <Modal
          isOpen={lightboxOpen}
          onRequestClose={() => setLightboxOpen(false)}
          contentLabel="Imagen"
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#000",
              border: "none",
              padding: 0,
              width: "80%",
              height: "auto",
              maxWidth: "600px",
              maxHeight: "80%",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.75)",
            },
          }}
        >
          <img
            src={currentImage}
            alt="Imagen ampliada"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        </Modal>
      )}
    </>
  );
}
